import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import CaliLetters from './CaliLetters';

const SLIDES = [
  { img: '/products/s1.jpg', title: 'Cali Boyz Nowosci', sub: 'Nowe smaki, nowe grafiki, nowy poziom.' },
  { img: '/products/prod-shotyy.jpg', title: 'Shoty Cali Boyz', sub: 'Kompaktowa forma i mocny charakter.' },
  { img: '/products/s3.jpg', title: 'Premium Selection', sub: 'Sprawdz najnowsze produkty w ofercie.' },
  { img: '/products/slide-d.jpg', title: 'Szumi las, że szyszki lecą!', sub: 'Cali Pine 50MG THC — już wkrótce' },
  { img: '/products/slide-c.jpg', title: 'Kokos który robi robotę!', sub: 'Cali Coco Choc — już wkrótce' },
  { img: '/products/slide-a.jpg', title: 'Cali Tea — Limited Edition', sub: 'Twój styl. Twoja chwila. Twoja California.' },
];

const PromoSlider = () => {
  const [i, setI] = useState(0);
  const go = useCallback((n) => setI((prev) => (n + SLIDES.length) % SLIDES.length), []);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-4 lg:px-8 py-10">
      <div className="relative rounded-3xl overflow-hidden border border-white/10 group">
        <div className="relative aspect-[16/9] sm:aspect-[21/9] bg-black">
          {SLIDES.map((s, idx) => (
            <div
              key={idx}
              className={`absolute inset-0 transition-opacity duration-700 ${idx === i ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            >
              <img src={s.img} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full scale-110 object-cover blur-2xl opacity-60" />
              <div className="absolute inset-0 bg-black/30" />
              <img src={s.img} alt={s.title} className="relative z-10 h-full w-full object-contain p-2 sm:p-4" />
              <div className="absolute inset-x-0 bottom-0 z-20 bg-gradient-to-t from-black/85 via-black/35 to-transparent px-5 pb-5 pt-16 sm:px-8 sm:pb-8">
                <h3 className="font-bangers text-2xl sm:text-4xl lg:text-5xl">
                  <CaliLetters text={s.title.toUpperCase()} />
                </h3>
                <p className="text-white/80 text-sm sm:text-base mt-1">{s.sub}</p>
              </div>
            </div>
          ))}
        </div>

        <button onClick={() => go(i - 1)} className="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center rounded-full bg-black/60 border border-white/15 text-white hover:bg-[#a6e22e] hover:text-black transition opacity-0 group-hover:opacity-100">
          <ChevronLeft size={20} />
        </button>
        <button onClick={() => go(i + 1)} className="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 grid place-items-center rounded-full bg-black/60 border border-white/15 text-white hover:bg-[#a6e22e] hover:text-black transition opacity-0 group-hover:opacity-100">
          <ChevronRight size={20} />
        </button>

        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
          {SLIDES.map((_, idx) => (
            <button key={idx} onClick={() => setI(idx)} className={`h-2 rounded-full transition-all ${idx === i ? 'w-6 bg-[#a6e22e]' : 'w-2 bg-white/40'}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromoSlider;
